var render = function render(){var _vm=this,_c=_vm._self._c;return _c('history-api',{ref:"history",on:{"popstate":state => _vm.sync(state || _vm.defaultQuery, false)},scopedSlots:_vm._u([{key:"default",fn:function({ pushState }){return [_c(_vm.component,{tag:"component",on:{"navigated":function($event){return pushState({ page: $event }, _vm.url, { preserveScroll: false })}}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }